import {CrmContactsRoutes} from 'blackswan-api';
import {Api} from "laravel-request";

import {sortContacts} from "#app/domain/chat/sortContacts";

import {makeRequest} from "../chats/makeRequest";
import type { ChatLastMessageEntry } from "../chats/types";
import {ChatItemDTO, ChatContactDTO, type ChatContactRaw} from "../dto/chatDTO";
import {clearChatId} from "../middleware/websocketConnector";



export const chatRequest = (
    contacts: ChatContactDTO[],
    data: { id: number },
    phones: string[],
    setContacts: (contacts: ChatItemDTO[]) => void,
    setContactsLoaded: (loaded: boolean) => void,
    setContactsError?: (error: string | null) => void
) => {
    makeRequest({
        url: 'chat/last',
        data: {phones},
        userId: data?.id,
        callback: (responseData: any): void => {
            const messagesByPhone = (responseData ?? {}) as Record<string, any>;
            const uniqueContacts = getUniqueContacts(contacts, clearChatId);
            const chatDTOs = getChatItemsList(uniqueContacts, messagesByPhone, clearChatId);
            setContacts(sortContacts(chatDTOs));
            setContactsLoaded(true);
            setContactsError?.(null);
        },
        errorCallback: () => {
            setContactsLoaded(true);
            setContactsError?.('Сервис чатов недоступен или контакты отсутствуют');
        }
    })
};

const getUniqueContacts = (
    contacts: ChatContactDTO[],
    normalizePhone: (phone: string | null) => string
): ChatContactDTO[] => {
    const seenPhones = new Set<string>();
    return contacts.filter(contact => {
        const phone = normalizePhone(contact.phone || '');
        if (phone && seenPhones.has(phone)) return false;
        if (phone) seenPhones.add(phone);
        return true;
    });
};

const getChatItemsList = (
    uniqueContacts: ChatContactDTO[],
    responseData: Record<string, any>,
    normalizePhone: (phone: string | null) => string
): ChatItemDTO[] => {
    return uniqueContacts.map(contact => {
        const phone = normalizePhone(contact.phone || '');
        const raw = contact as any as ChatContactRaw;
        const message = phone ? responseData[phone] : undefined;
        return ChatItemDTO.create(raw, phone, (message ?? {}) as ChatLastMessageEntry);
    });
};

export const fetchContacts = (
    setContacts: (contacts: ChatItemDTO[]) => void,
    setContactsLoaded: (loaded: boolean) => void,
    data: { id: number },
    setContactsError?: (error: string | null) => void
) => {
    CrmContactsRoutes.index(
        (response: { data: Array<Record<string, any>> }) => {
            const rawContacts = response?.data ?? [];
            const contactDtos = rawContacts.map((row) => ChatContactDTO.fromRaw(row as ChatContactRaw));

            const phones = contactDtos
                .map((contact) => clearChatId(contact.phone || ""))
                .filter((phone) => phone.length > 0);

            chatRequest(contactDtos, data, phones, setContacts, setContactsLoaded, setContactsError);
        }, ['client'], {},
    )
}

/**
 * Тогглер переключения статуса клиента "В архиве"
 */
export const setContactArchived = (
    contactId: number | string,
    isArchived: boolean | number,
    refuseReasonId: number = 1
) => {
    return Api.putArg(
        'crm-contact',
        'archive',
        contactId,
        {is_archive: isArchived, refuse_reason_id: (isArchived !== 0) ? refuseReasonId : null}
    );
}
